import { useContext } from "react";
import { AuthContext, AuthContextType } from "./authContext";

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const useAuthState = () => {
    const { user, loading, isAuthenticated, isSuperAdmin, canAccessInternalTools } = useAuth();

    return {
        user,
        loading,
        isAuthenticated,
        isSuperAdmin,
        canAccessInternalTools,
    };
};
